// extracted by mini-css-extract-plugin
export default {"tabs":"index_tabs_vxDA5","itis":"index_itis_cGKn5","list":"index_list_SXM5P","number1":"index_number1_qoET4","number2":"index_number2_3HVQx"};